import React from 'react';
import {
  Typography,
  TypographyType,
  TypographyVariant,
} from '../../../../../../../components-dummy';
import { TextFieldStyled } from './EmailDisplaySettingsSection.styles';

interface Props {
  field: string;
  defaultValue: number;
  value: number;
  adornment: string;
  onChange: (field: string, value: any) => void;
  label?: string;
  inputProps?: {
    min?: number;
    max?: number;
    step?: number;
  };
  error?: boolean;
}

export const TextFieldWithAdornment = ({
  field,
  defaultValue,
  value,
  adornment,
  onChange,
  label,
  inputProps,
  error,
}: Props) => {
  const handleChange = e => onChange(field, Number(e.target.value));

  return (
    <>
      {label && (
        <Typography variant={TypographyVariant.MediumRegular} type={TypographyType.Body}>
          {label}
        </Typography>
      )}
      <TextFieldStyled
        type='number'
        value={value || defaultValue}
        onChange={handleChange}
        InputProps={{
          endAdornment: <span style={{ marginLeft: 8 }}>{adornment}</span>,
        }}
        variant='outlined'
        size='small'
        inputProps={{
          ...inputProps,
          onWheel: e => e.currentTarget.blur(),
        }}
        error={error}
      />
    </>
  );
};
